import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "maxSelect", "items", "itemsPerPage", "actions", "objectIsDisabled", "onClick", "onDoubleClick", "idProp", "isDisabled", "isInteractive", "isSelectable", "isLoading", "showActionBar"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import cn from 'classnames';
import { find, isUndefined } from 'lodash-es';
var warning = require('warning');
import { IconChevronDown, IconChevronUp, IconEllipsisVert } from '../../../icons';
import { safeInvoke, isElementOfType, isFunction, isTruthy, isDefined, keys } from '../../../library';
import { ActionBar, ObjectList } from '../../object-list';
import { Popover } from '../../popover';
import { Button } from '../../button';
import { Overlay } from '../../overlay';
import { Table } from '../../table';
import { Loader } from '../../loader';
import { Heading, Pane } from '../..';
var objectTableClasses = {
  TABLE: 'object-table',
  SELECTOR: 'row-selector',
  LOADING_OVERLAY: 'object-table__loader',
  SELECTOR_COLUMN: 'selector-col'
};
export var ObjectTableColumn = function (_React$PureComponent) {
  _inherits(ObjectTableColumn, _React$PureComponent);
  var _super = _createSuper(ObjectTableColumn);
  function ObjectTableColumn() {
    _classCallCheck(this, ObjectTableColumn);
    return _super.apply(this, arguments);
  }
  return _createClass(ObjectTableColumn);
}(React.PureComponent);
_defineProperty(ObjectTableColumn, "displayName", 'ObjectTableColumn');
_defineProperty(ObjectTableColumn, "defaultProps", {
  isVisible: true
});
export var ObjectTable = function (_React$Component) {
  _inherits(ObjectTable, _React$Component);
  var _super2 = _createSuper(ObjectTable);
  function ObjectTable() {
    var _this;
    _classCallCheck(this, ObjectTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isSelectMode: false
    });
    _defineProperty(_assertThisInitialized(_this), "_clickTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "listRef", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "getChildColumns", function () {
      if (React.Children.count(_this.props.children) === 0) return [];
      var children = React.Children.map(_this.props.children, function (child) {
        if (isElementOfType(child, ObjectTableColumn)) {
          return child.props;
        }
        return null;
      });
      if (isTruthy(children)) return children.filter(function (col) {
        return col !== null;
      }).filter(function (col) {
        return col.isVisible;
      });
      return [];
    });
    _defineProperty(_assertThisInitialized(_this), "getOppositeDirection", function (direction) {
      switch (direction) {
        case 'asc':
          return 'desc';
        case 'desc':
          return 'asc';
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (items) {
      _this.setState({
        isSelectMode: items.length > 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleHeaderClick", function (e) {
      var id = e.currentTarget.dataset['id'];
      var column = find(_this.getChildColumns(), {
        id: id
      });
      if (isUndefined(column)) return;
      var sortDir = isDefined(_this.props.currentSort) && _this.props.currentSort[0] === column.id ? _this.getOppositeDirection(_this.props.currentSort[1]) : 'asc';
      safeInvoke(_this.props.onSortChange, column.id, sortDir);
    });
    _defineProperty(_assertThisInitialized(_this), "handleHeaderKeyUp", function (e) {
      if (e.keyCode !== keys.ENTER) return;
      var id = e.currentTarget.dataset['id'];
      var column = find(_this.getChildColumns(), {
        id: id
      });
      if (isUndefined(column)) return;
      var sortDir = isDefined(_this.props.currentSort) && _this.props.currentSort[0] === column.id ? _this.getOppositeDirection(_this.props.currentSort[1]) : 'asc';
      safeInvoke(_this.props.onSortChange, column.id, sortDir);
    });
    _defineProperty(_assertThisInitialized(_this), "renderTableHeader", function (columns, api) {
      return React.createElement(React.Fragment, null, React.createElement("colgroup", null, _this.props.isSelectable ? React.createElement("col", {
        key: "select"
      }) : null, columns.map(function (column) {
        if (!column.isVisible) return null;
        return React.createElement("col", {
          key: column.id,
          width: column.width
        });
      }), _this.props.actions ? React.createElement("col", {
        key: "action"
      }) : null), React.createElement("thead", {
        className: cn(_defineProperty({}, "-".concat(_this.props.headerBG), _this.props.headerBG !== 'none'))
      }, React.createElement("tr", null, _this.props.isSelectable ? React.createElement("th", {
        className: objectTableClasses.SELECTOR_COLUMN
      }, React.createElement("div", {
        className: cn(objectTableClasses.SELECTOR, {
          '-active': api.isAllSelected(),
          '-disabled': _this.props.isDisabled
        }),
        onClick: api.selectAllToggle
      })) : null, columns.map(function (column) {
        if (!column.isVisible) return null;
        var isSorting = isDefined(_this.props.currentSort) && _this.props.currentSort[0] === column.id;
        var sortIcon = null;
        if (column.isSortable) {
          if (isDefined(_this.props.currentSort) && _this.props.currentSort[0] === column.id && _this.props.currentSort[1] === 'asc') {
            sortIcon = React.createElement(IconChevronUp, {
              color: isSorting ? 'primary' : undefined
            });
          } else {
            sortIcon = React.createElement(IconChevronDown, {
              color: isSorting ? 'primary' : undefined
            });
          }
        }
        return React.createElement("th", {
          className: cn({
            '-sortable': column.isSortable && !_this.props.isDisabled,
            '-overflow': column.allowHeaderOverflow,
            '-active-sort': isSorting
          }),
          style: {
            minWidth: column.minWidth
          },
          key: column.id,
          "data-id": column.id,
          onClick: column.isSortable && !_this.props.isDisabled ? _this.handleHeaderClick : undefined,
          onKeyUp: _this.handleHeaderKeyUp,
          role: column.isSortable ? 'button' : undefined,
          tabIndex: column.isSortable ? 0 : undefined
        }, React.createElement("div", {
          className: "thead__inner"
        }, React.createElement("div", {
          className: cn('thead__inner-wrap', {
            'justify--center': column.textAlign === 'center',
            'justify--end': column.textAlign === 'right'
          })
        }, React.createElement("span", {
          className: "thead__text",
          title: column.header
        }, column.header), column.isSortable ? React.createElement(Pane, {
          as: "span",
          paddingLeft: 2
        }, sortIcon) : null)));
      }), isDefined(_this.props.actions) ? React.createElement("th", null) : null)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderFallback", function () {
      var _this$props$fallback;
      return (_this$props$fallback = _this.props.fallback) !== null && _this$props$fallback !== void 0 ? _this$props$fallback : React.createElement(Pane, {
        padding: [1]
      }, React.createElement(Heading, {
        size: "sm",
        align: "center",
        isUppercase: true
      }, "No Items"));
    });
    return _this;
  }
  _createClass(ObjectTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        maxSelect = _this$props.maxSelect,
        items = _this$props.items,
        itemsPerPage = _this$props.itemsPerPage,
        actions = _this$props.actions,
        objectDisabled = _this$props.objectIsDisabled,
        onClick = _this$props.onClick,
        onDoubleClick = _this$props.onDoubleClick,
        idProp = _this$props.idProp,
        isDisabled = _this$props.isDisabled,
        isInteractive = _this$props.isInteractive,
        isSelectable = _this$props.isSelectable,
        isLoading = _this$props.isLoading,
        showActionBar = _this$props.showActionBar,
        tableProps = _objectWithoutProperties(_this$props, _excluded);
      var childColumns = this.getChildColumns();
      var colCount = childColumns.length;
      if (this.props.isSelectable) colCount++;
      if (isDefined(this.props.actions)) colCount++;
      if (childColumns.length === 0) {
        warning(false, 'You must have at least one child Column to render an ObjectTable');
        return null;
      }
      return React.createElement(ObjectList, {
        className: cn(objectTableClasses.TABLE, className),
        getApi: this.props.getApi,
        maxSelect: maxSelect,
        items: items,
        itemsPerPage: itemsPerPage,
        actions: actions,
        objectIsDisabled: objectDisabled,
        idProp: idProp,
        isDisabled: isDisabled,
        isSelectable: isSelectable,
        onSelectChange: this.handleSelectChange
      }, function (_ref) {
        var items = _ref.items,
          selectedItems = _ref.selectedItems,
          actions = _ref.actions,
          api = _ref.api;
        return React.createElement("div", {
          className: cn(objectTableClasses.TABLE, {
            '-select-mode': _this2.state.isSelectMode
          })
        }, isLoading && React.createElement("div", {
          className: cn(objectTableClasses.LOADING_OVERLAY, {
            '-active': isLoading
          })
        }, React.createElement(Loader, {
          isLoading: isLoading,
          delay: 0
        })), React.createElement(Table, _extends({}, tableProps, {
          isInteractive: !isDisabled && (isInteractive || _this2.state.isSelectMode || isFunction(onClick) || isFunction(onDoubleClick))
        }), _this2.renderTableHeader(childColumns, api), React.createElement("tbody", null, items.map(function (item) {
          return React.createElement(Row, {
            key: item[_this2.props.idProp] + '',
            item: item,
            api: api,
            isDisabled: _this2.props.isDisabled,
            columns: _this2.getChildColumns(),
            actionDropdownLabel: _this2.props.actionDropdownLabel,
            onClick: _this2.props.onClick,
            onDoubleClick: _this2.props.onDoubleClick,
            isSelectable: _this2.props.isSelectable,
            isSelectMode: _this2.state.isSelectMode,
            verticalAlign: _this2.props.verticalAlign
          });
        }), _this2.props.items.length > 0 ? null : React.createElement("tr", null, isTruthy(_this2.props.isLoading) ? React.createElement("td", {
          colSpan: colCount
        }) : React.createElement("td", {
          colSpan: colCount
        }, _this2.renderFallback())))), !isSelectable || !showActionBar ? null : React.createElement(Overlay, {
          className: "action-bar-wrapper",
          hasBackdrop: false,
          isOpen: selectedItems.length > 0,
          usePortal: false,
          transitionDuration: 0,
          isLazy: false
        }, React.createElement(ActionBar, {
          actions: actions,
          selected: selectedItems,
          deselectAll: api.deselectAll
        })));
      });
    }
  }]);
  return ObjectTable;
}(React.Component);
_defineProperty(ObjectTable, "defaultProps", {
  items: [],
  isSelectable: false,
  currentSort: null,
  isLoading: false,
  actionDropdownLabel: React.createElement(IconEllipsisVert, null),
  headerBG: 'none',
  isDisabled: false
});
_defineProperty(ObjectTable, "Column", ObjectTableColumn);
var Row = function Row(props) {
  var clickTimeout = React.useRef(null);
  var isSelectable = props.isSelectable,
    api = props.api,
    item = props.item,
    isDisabled = props.isDisabled;
  var actionMenu = api.renderActionMenu(item);
  var isSelected = api.isSelected(item);
  var getClickHandler = function getClickHandler(onClick, onDblClick) {
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    if (clickTimeout.current === null) {
      var timeout = window.setTimeout(function () {
        onClick();
        clickTimeout.current = null;
      }, delay);
      clickTimeout.current = timeout;
    } else {
      clearTimeout(clickTimeout.current);
      clickTimeout.current = null;
      onDblClick();
    }
  };
  var handleClick = function handleClick(e) {
    if (isDisabled || e.defaultPrevented) return;
    e.persist();
    if (props.isSelectMode) {
      api.handleSelect(e, item, true);
    } else {
      getClickHandler(function () {
        return safeInvoke(props.onClick, item, e);
      }, function () {
        return safeInvoke(props.onDoubleClick, item, e);
      }, isFunction(props.onDoubleClick) ? 200 : 0);
    }
  };
  var handleSelectorClick = function handleSelectorClick(e) {
    if (isDisabled) return;
    e.preventDefault();
    api.toggleSelect(item);
  };
  return React.createElement("tr", {
    className: cn(_defineProperty({
      '-selected': isSelected,
      '-disabled': isDisabled
    }, "-valign--".concat(props.verticalAlign), props.verticalAlign)),
    onClick: handleClick
  }, isSelectable ? React.createElement("td", {
    key: "col-selector",
    className: objectTableClasses.SELECTOR_COLUMN,
    align: "center"
  }, React.createElement("div", {
    className: cn(objectTableClasses.SELECTOR),
    onClick: handleSelectorClick
  })) : null, props.columns.map(function (column) {
    if (!column.isVisible) return null;
    var key = "col-".concat(column.id, "}");
    var classNames = cn(column.className, _defineProperty(_defineProperty({}, "t--v-".concat(column.verticalAlign), column.verticalAlign), "t--".concat(column.textAlign), column.textAlign));
    if (column.children) {
      return React.createElement("td", {
        key: key,
        className: classNames,
        style: column.style
      }, safeInvoke(column.children, item));
    } else if (column.renderCell) {
      return React.createElement("td", {
        key: key,
        className: classNames
      }, isFunction(column.renderCell) ? column.renderCell(item) : item[column.renderCell]);
    } else {
      warning(false, 'You need to provide either the renderCell or children prop to an ObjectTableColumn.');
      return React.createElement("td", {
        key: key
      });
    }
  }), actionMenu == null ? null : React.createElement("td", {
    key: "col-action",
    className: "-shrink",
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, React.createElement(Popover, {
    content: actionMenu,
    position: "bottom",
    boundary: "viewport",
    isDisabled: isDisabled
  }, React.createElement(Button, {
    density: 'compact',
    size: "small",
    appearance: "minimal",
    isDisabled: isDisabled,
    isSquare: true
  }, props.actionDropdownLabel))));
};